/** @format */

export { popularBrands } from './config/constants';
export { getFilteredBrandsByShortList } from './helpers';
